export default {"src":"/_next/static/media/info-icon.9b5b15cf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};